<template>
  <VueDragResize class="wordcloud-overlay" :parentLimitation="false" :isResizable="false" :z="z" :x="leftComputed" :y="topComputed" @dragging="dragging" @dragstop="dragstop" @clicked="updateZ" :style="{ opacity: opacity }">
    <div class="wordcloud-header">
      <h3 class="wordcloud-box-title" v-html="panelTitle"></h3>
      <div class="wordcloud-close-button" @click.prevent="hide" @touchstart="hide">X</div>
    </div>
    <p v-if="!sent" class="wordcloud-prompt-text" v-html="prompt"></p>
    <input ref="input" v-focus v-if="!sent" type="text" class="input-word" spellcheck="false" maxlength="42" v-model="word" @keypress="checkSend" @click.prevent="passFocus" @touchstart="passFocus" />
    <button v-if="!sent" class="word-send-button" @click.prevent="sendWord" @touchstart="sendWord">{{ sendText }}</button>
    <span v-if="sent" class="wordcloud-thanks">
      <p v-html="postSendText"></p>
      <iframe id="iframe" :src="iframeSrc" frameborder="0" v-if="iframeSrc"></iframe>
    </span>
  </VueDragResize>
</template>

<script>
import api from '@/services/api';
import VueDragResize from 'vue-drag-resize';

export default {
  name: 'WordCloudPrompt',
  components: {
    VueDragResize,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },

  props: {
    wordcloud: Object,
    wordcloud_id: String,
    prompt: String,
    sendText: String,
    postSendText: String,
    isMobile: Boolean,
    isVideoFullscreen: Boolean,
    panelTitle: String,
    z: Number,
    topRef: Number,
    leftRef: Number,
  },

  data() {
    return {
      word: '',
      sent: false,
      width: 0,
      height: 0,
      counter: 1,
      isDragging: false,
      iframeSrc: '',
      top: 0,
      left: 0,
    };
  },
  methods: {
    checkSend(key) {
      // console.log('SCROLLTop: ' + this.$refs.messagesContainer.scrollTop);
      if (key.keyCode == 13) this.sendWord();
    },
    sendWord() {
      if (this.isDragging) return;
      if (!this.word.length) return;

      // console.log(this.wordcloud_id);

      api
        .post(`/addWordToCloud/${this.$route.params.stream}/${this.wordcloud_id}`, {
          userId: this.$store.state.user.id,
          wordcloud_id: this.wordcloud_id,
          word: this.word,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          api.post(`sessionAction/`, {
            action: 'WordCloud New Word',
            properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          this.sent = true;

          let parsedData = { type: { showResults: false } };
          try {
            if (this.wordcloud && typeof this.wordcloud.raw_data === 'string') {
              parsedData = JSON.parse(this.wordcloud.raw_data);
            } else if (this.wordcloud && typeof this.wordcloud === 'object') {
              // parent may already pass a parsed object
              parsedData = this.wordcloud;
            }
          } catch (error) {
            console.error('Error parsing wordcloud raw_data:', error);
          }
          const showResults = parsedData && parsedData.type && parsedData.type.showResults;
          if (showResults) {
            // emit event to update wordcloud with new word (run checkWords on parent)
            console.log('Emitting update-wordcloud event with id:', this.wordcloud_id);
            this.$emit('update-wordcloud', { id: this.wordcloud_id });
            setTimeout(() => {
              this.viewWordcloud(this.wordcloud_id);
            }, 1000);
          }
        })
        .catch((err) => {
          console.error('error adding word', err);
        });
    },
    hide() {
      this.$emit('close');
      this.sent = false;
    },
    passFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    dragging(newRect) {
      this.isDragging = true;
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    dragstop() {
      this.isDragging = false;
    },
    updateZ() {
      this.counter++;
      if (this.counter > 1) {
        this.counter = 1;
        this.$emit('bringToFront', 'wordcloud');
      }
    },
    onMessage(msg) {
      let winRef = msg.source;
      let parsedMsg;
      try {
        parsedMsg = JSON.parse(msg.data);
      } catch (err) {
        return;
      }
      if (parsedMsg.type == 'get-wordcloud') {
        let words = [];
        if (this.wordcloud && Array.isArray(this.wordcloud.interactions)) {
          this.wordcloud.interactions.forEach((inter) => {
            words.push([inter.answer, inter.interactions]);
          });
        }

        if (winRef && typeof winRef.postMessage === 'function') {
          winRef.postMessage(JSON.stringify({ type: 'wordcloud-data', data: words }), '*');
        }
      }
    },
    viewWordcloud(id) {
      this.iframeSrc = `//proto-assets.s3.amazonaws.com/dataviz/wordcloud/wordcloud_mini.html#/${id}`;
    },
  },
  computed: {
    topComputed() {
      return this.topRef;
    },
    leftComputed() {
      return this.leftRef + 10;
    },
    opacity() {
      return this.z == 2 ? 1 : 0.7;
    },
  },
  beforeMount() {
    this.top = this.topRef;
    this.left = this.leftRef;
    if (this.isMobile) {
      this.top = 100;
      this.left = 50;
    }
  },
  mounted() {
    window.addEventListener('message', this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },
};
</script>

<style lang="scss">
.wordcloud-overlay {
  position: fixed !important;
  top: 38%;
  left: 78px;
  min-width: 400px;
  max-width: 520px;
  border-radius: var(--input-borderRadius);

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.6);
    backdrop-filter: blur(20px) brightness(0.6);
  }

  @include media('<=phone-plus') {
    position: fixed;
    inset: 10px auto auto 40px;
    min-width: unset;
  }
  .content-container {
    width: 100% !important;
    height: 100% !important;
    @include media('<=phone-plus') {
      width: 300px !important;
      max-width: 300px !important;
    }
  }
  .wordcloud-prompt-text {
    color: white;
    font-size: 0.95rem;
    padding: 10px 16px 4px;
    margin: 0;
    line-height: 1.4;
    opacity: 0.9;
    word-break: break-word;
    white-space: pre-wrap;
    text-align: center;
  }
  .input-word {
    // caret-color: red;
    font-size: 1.1rem;
    letter-spacing: 1px;
    outline: none;
    border: none;
    resize: none;
    padding: 10px;
    height: 48px;
    width: 100%;
    color: white;
    background: transparent;
    border-radius: var(--input-borderRadius);

    margin: 6px 0;
    text-align: center;
    cursor: text;

    &::placeholder {
      color: white;
      opacity: 0.5;
      cursor: auto;
    }
  }
  .word-send-button {
    position: relative;
    width: 96%;
    padding: 2% 8%;
    margin: 0 0 10px 10px;
    z-index: 10;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--live-textColor);
    // opacity: 0.8;
    background-color: var(--live-bgColor);
    // border-radius: var(--input-borderRadius);
    border: none;
    border-top: 2px solid var(--live-bgColor);
    border-radius: var(--input-borderRadius);
    outline: none;
    cursor: pointer;
  }
}
.input-word {
  height: auto !important;
  margin: 6px 0;
  text-align: center;
}
.wordcloud-header {
  position: relative;
  width: 100%;
  padding: 1.6% 8%;
  z-index: 10;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  color: var(--live-textColor);
  // opacity: 0.8;
  background-color: var(--live-bgColor);
  // border-radius: var(--input-borderRadius);
  border: none;
  border-top: 2px solid var(--live-bgColor);
  border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
  outline: none;
  cursor: grab;
}
.wordcloud-box-title {
  // background: var(--live-bgColor);
  color: var(--live-textColor);
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
}
.wordcloud-close-button {
  position: absolute;
  right: 4px;
  top: 0px;
  height: 100%;
  // width: 300px;
  z-index: 8;
  margin-top: auto;
  color: var(--live-textColor);
  margin-left: 8px;
  margin-right: 0px;
  margin-bottom: 3px;
  background: transparent;
  border-radius: var(--input-borderRadius);
  padding: 6px 9px 0;
  font-size: 0.8rem;
  font-weight: 300;
  text-align: left;
  cursor: pointer;
}
.wordcloud-thanks {
  position: relative;
  // width: auto;
  min-height: 100px;
  height: 100%;
  color: whitesmoke;
  opacity: 0.8;
  font-weight: bold;
  border-radius: var(--input-borderRadius);
  padding: 0px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    margin: 10px 0 0;
  }

  iframe {
    height: 100%;
    min-height: 140px;
    width: 100%;
    flex-grow: 1;
    margin: 10px 0 16px;
  }
}
</style>
